import { deleteData, getData , postData, putData } from './index';

import {
  GET_ORDERS_LIST,
  ERROR_ORDERS,
  MESSAGE_ORDERS,
  GET_PRODUCTS_LIST,
  GET_ORDER,
  EXPORT_ORDERS,
  VALIDATE_ORDER,
  DELETE_ORDER,
  GET_ORDERS_FILTERED
} from "./types"

export async function getOrdersListAction(dispatch){
  let url = "/company/fournisseur"
  let fournisseurs;
  await getData( ERROR_ORDERS, url, dispatch , true).then((response)=>{
    fournisseurs = response.companies.map((c) => ({ value: c._id, label: c.name }));
  })
  url = "/company/magasin"
  let magasins;
  await getData( ERROR_ORDERS, url, dispatch , true).then((response)=>{
    magasins = response.companies.map((c) => ({ value: c._id, label: c.name }));
  })
  dispatch({
    type : GET_ORDERS_LIST,
    payload :{
      fournisseurs,
      magasins,
    }
  })
}

export async function getProductsAction(dispatch){
  let url = "/product"
  let products;
  await getData( ERROR_ORDERS, url, dispatch , true).then((response)=>{
    products = response.products
  })
  dispatch({
    type : GET_PRODUCTS_LIST,
    payload : products
  })
}

export async function getOrdersFilteredAction(dispatch , filters){
  let url = "/order/filtered"
  let products;
  await postData(GET_ORDERS_FILTERED , ERROR_ORDERS , url, dispatch , filters, true ).then((response)=>{
    products = response.orders;
  })
  dispatch({
    type : GET_ORDERS_FILTERED,
    payload : products
  })
}


export async function postOrderAction(dispatch , obj ){
  let url = "/order"
  let createOrder;
  await postData(MESSAGE_ORDERS , ERROR_ORDERS , url, dispatch , obj, true ).then((response)=>{
    createOrder = response
  });
  dispatch({
    type : MESSAGE_ORDERS,
    payload : createOrder
  })
}

export async function getOrderAction(dispatch , id){
  let url = "/order/" + id 
  let offer;
  await getData( ERROR_ORDERS, url, dispatch , true).then((response)=>{
    offer = response.order
  })
  dispatch({
    type : GET_ORDER,
    payload : offer
  })
}

export async function exportOrdersAction(dispatch , obj ){
  let url = "/export/order"
  let exportList;
  await postData(EXPORT_ORDERS , ERROR_ORDERS , url, dispatch , obj, true ).then((response)=>{
    exportList = response
  });
  dispatch({
    type : EXPORT_ORDERS,
    payload : exportList
  })
}

export async function validateOrdersAction(dispatch , obj ){
  let url = "/order/validate"
  let validate;
  await postData(VALIDATE_ORDER , ERROR_ORDERS , url, dispatch , obj, true ).then((response)=>{
    validate = response
  });
  dispatch({
    type : VALIDATE_ORDER,
    payload : validate
  })
}


export async function putOrderAction(dispatch , id , obj ){
  let url = "/order/" + id 
  let order;
  await putData(GET_ORDER , ERROR_ORDERS , url, dispatch , obj, true ).then((response)=>{
    order = response.order
  });
  dispatch({
    type : GET_ORDER,
    payload : order
  })
}


export async function deleteOrderAction(dispatch , id ){
  let url = "/order/" + id 
  let order;
  await deleteData(ERROR_ORDERS , url, dispatch, true ).then((response)=>{
    order = response
  });
  if (order) {
    dispatch({
      type : DELETE_ORDER,
      payload : id,
    });
  }
}
